import type { ResponseHandlingItemDto } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { computed, type Ref } from 'vue';

export const useResponseData = <
  TStatus extends number,
  TData,
  TResponse extends { data: TData; status: TStatus },
  TSuccessStatus extends TStatus = 200 & TStatus,
>(
  response: Ref<TResponse | undefined>,
  successStatus: TSuccessStatus = 200 as TSuccessStatus,
) => {
  return computed<(TData & (TResponse & { status: TSuccessStatus })['data']) | undefined>(() =>
    response.value?.status === successStatus ? response.value?.data : undefined,
  );
};
